module.exports = __webpack_public_path__ + "static/media/whoweare.6faa65b7.jpg";